import React from "react";
import SectionLabel from "../components/SectionLabel";
import { VALUES, MEDIA, COMPANY } from "../data/content";

const About = () => {
  return (
    <>
      <section
        className="border-b border-[var(--sifra-line)] bg-white"
        data-testid="about-hero"
      >
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28 grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-7">
            <SectionLabel>About {COMPANY.name}</SectionLabel>
            <h1 className="font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-[1] mt-6">
              A technology partner
              <br />
              <span className="text-[var(--sifra-ink-mute)]">built on trust</span>
              <br />
              since {COMPANY.established}.
            </h1>
          </div>
          <div className="md:col-span-5 flex flex-col justify-end">
            <p className="text-[var(--sifra-ink-soft)] text-base md:text-lg leading-relaxed">
              Sifra Enterprises is a trusted provider of corporate IT hardware and
              technology solutions. We specialise in high-quality, genuine IT
              products — and pair them with dedicated service, competitive pricing
              and quick turnaround times, so our clients never stop moving.
            </p>
          </div>
        </div>
      </section>

      <section className="bg-white border-b border-[var(--sifra-line)]" data-testid="about-mv">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-24 md:py-32 grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-6 border border-[var(--sifra-line)] p-10 md:p-14">
            <SectionLabel>Mission</SectionLabel>
            <h3 className="font-display font-black text-2xl sm:text-3xl tracking-tighter mt-6 mb-6">
              To be the most reliable hands in your IT stack.
            </h3>
            <ul className="space-y-4 text-[var(--sifra-ink-soft)] text-base">
              <li className="flex gap-3">
                <span className="font-display font-black text-[var(--sifra-ink)]">→</span>
                Supply high-quality IT products at competitive pricing.
              </li>
              <li className="flex gap-3">
                <span className="font-display font-black text-[var(--sifra-ink)]">→</span>
                Deliver safe, long-lasting solutions backed by warranty and support.
              </li>
              <li className="flex gap-3">
                <span className="font-display font-black text-[var(--sifra-ink)]">→</span>
                Maintain strong relationships through quick delivery, responsiveness and transparency.
              </li>
            </ul>
          </div>
          <div className="md:col-span-6 border border-[var(--sifra-ink)] bg-[var(--sifra-ink)] text-white p-10 md:p-14">
            <SectionLabel dark>Vision</SectionLabel>
            <h3 className="font-display font-black text-2xl sm:text-3xl tracking-tighter mt-6 mb-6">
              To be the most preferred IT hardware partner for corporate India.
            </h3>
            <p className="text-white/70 leading-relaxed">
              We want to be the first name that comes to mind when a CIO or a
              procurement lead needs hardware that arrives on time, works the way
              it should, and is backed by people who actually pick up the phone.
            </p>
          </div>
        </div>
      </section>

      <section className="bg-[var(--sifra-bg)] border-b border-[var(--sifra-line)]" data-testid="about-values">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-24 md:py-32">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-8 items-end mb-14">
            <div className="md:col-span-8">
              <SectionLabel>Core Values</SectionLabel>
              <h2 className="font-display font-black text-3xl sm:text-4xl lg:text-5xl tracking-tighter mt-4">
                Five principles, practised every day.
              </h2>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-5 border border-[var(--sifra-line)] bg-white">
            {VALUES.map((v, i) => (
              <div
                key={v.id}
                data-testid={`value-card-${v.id}`}
                className={`p-8 md:p-10 min-h-[280px] flex flex-col justify-between ${
                  i < VALUES.length - 1
                    ? "border-b md:border-b-0 md:border-r border-[var(--sifra-line)]"
                    : ""
                } hover:bg-[var(--sifra-ink)] hover:text-white transition-colors duration-500 group cursor-default`}
              >
                <div className="font-display font-black text-5xl md:text-6xl tracking-tighter text-[var(--sifra-ink-mute)] group-hover:text-white/40 transition-colors">
                  {v.id}
                </div>
                <div>
                  <div className="font-display font-black text-xl tracking-tighter mb-3">
                    {v.title}
                  </div>
                  <div className="text-sm text-[var(--sifra-ink-soft)] group-hover:text-white/70 transition-colors leading-relaxed">
                    {v.body}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-white" data-testid="about-image">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
          <div className="border border-[var(--sifra-line)] overflow-hidden aspect-[21/9]">
            <img
              src={MEDIA.architecture}
              alt="Corporate architecture"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default About;
